export enum DocumentTypeEnum {
  PRO_FORMA_INVOICE = "pro_forma_invoice",
  INVOICE = "invoice",
}
